module.exports = __webpack_public_path__ + "img/classroom.e2db3d06.svg";